import { CategoriasEnum, TipoSimulacaoEnum } from "../../utils/constants";

const getFilteredOptions = (options, tipoTabela) => {
  const getCategoryInfo = (categoriaID) => CategoriasEnum[categoriaID] || {};
  let filteredOptions = options;

  switch (tipoTabela) {
    // Fall-through for "integral_reduzida", "pagametade_reduzida", and "integral"
    case "integral_pagametade":
    case "integral_reduzida":
    case "pagametade_reduzida":
    case "integral":
      filteredOptions = options.filter(
        (option) =>
          getCategoryInfo(option.categoriaID)?.tipoPlano ===
          TipoSimulacaoEnum.CREDITO_INTEGRAL
      );
      break;
    case "pagametade":
      filteredOptions = options.filter(
        (option) =>
          getCategoryInfo(option.categoriaID)?.tipoPlano ===
          TipoSimulacaoEnum.CREDITO_PAGAMETADE
      );
      break;
    case "reduzida":
      filteredOptions = options.filter(
        (option) =>
          getCategoryInfo(option.categoriaID)?.tipoPlano ===
          TipoSimulacaoEnum.PARCELA_REDUZIDA
      );
      break;
    default:
      // filteredOptions remains as options
      break;
  }

  return filteredOptions;
};

export default getFilteredOptions;
